module.exports = __webpack_public_path__ + "static/media/weather_1.4d40d36e.gif";